var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_15x15_photo_back",
    "data-name": "15x15 photo back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4561",
    "data-name": "Rectangle 4561",
    width: 15,
    height: 15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_278",
    "data-name": "Mask Group 278",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21279",
    "data-name": "Path 21279",
    d: "M1.665,2.99v8.955a2.5,2.5,0,0,0,2.49,2.49h3.37a3.508,3.508,0,0,1,.3-1,3.816,3.816,0,0,1,2.04-1.96A2.448,2.448,0,0,1,8.8,9.455,2.477,2.477,0,0,1,11.28,6.98a2.359,2.359,0,0,1,.7.105,2.452,2.452,0,0,1,1,.58V2.99A2.49,2.49,0,0,0,10.5.5H4.155a2.493,2.493,0,0,0-2.49,2.49Zm3.02-.01h5.28a.5.5,0,0,1,0,1H4.685a.5.5,0,0,1,0-1Zm0,2.66h5.28a.5.5,0,0,1,0,1H4.685a.5.5,0,0,1,0-1Zm0,2.655h2.4a.5.5,0,0,1,0,1h-2.4a.5.5,0,0,1,0-1Z",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_370",
    "data-name": "Ellipse 370",
    cx: 1.725,
    cy: 1.725,
    r: 1.725,
    transform: "translate(9.555 7.73)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21280",
    "data-name": "Path 21280",
    d: "M8.73,15.5h5.1a.5.5,0,0,0,.5-.5A3.053,3.053,0,1,0,8.23,15a.5.5,0,0,0,.5.5Z",
    fill: "#8e8e8e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c085d0447d0f6f5279d6af5224da1c67.svg";
export { ForwardRef as ReactComponent };